import React from 'react';

const Projects = () => {
  const projects = [
    {
      title: 'Cybersecurity Threat Detection using Neural Logic Engine',
      description: 'Designed a hybrid CNN-RNN architecture integrated with a Neural Logic Engine for zero-day attack detection',
      tags: ['TensorFlow', 'Keras', 'NumPy', 'Pandas']
    },
    {
      title: ' Malicious URL Detection using Advanced Gradient Boosting Models',
      description: ' Built a model to detect phishing URLs using ensemble learning and feature extraction',
      tags: ['Python', 'Scikit-learn', 'XGBoost']
    },
    {
      title: ' PC Builder using Chatbot',
      description: 'Developed a website integrated with a chatbot that helps users select compatible PC components and validate configurations for better usability and automation',
      tags: ['python', 'css', 'html', 'JavaScript']
    },
    {
      title: 'Gen Z Words to English Translation',
      description: 'Built a transformer-based NLP model using BART and T5 to translate slang into formal English',
      tags: ['Python, PyTorch, Hugging Face Transformers']
    }
  ];

  return (
    <section id="projects" className="projects-section slide-in-section">
      <div className="container">
        <div className="section-header">
          <span className="section-number">04</span>
          <h2 className="section-title">FEATURED PROJECTS</h2>
          <p className="section-subtitle">A collection of my recent work and side projects</p>
        </div>

        <div className="projects-grid">
          {projects.map((project, idx) => (
            <div key={idx} className="project-card">
              <h3 className="project-title">{project.title}</h3>
              <p className="project-description">{project.description}</p>
              <div className="project-tags">
                {project.tags.map((tag, i) => (
                  <span key={i} className="tag">{tag}</span>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Projects;